// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-user-details-modal-modal_card-q9LS1 {
  width: 324px;
  height: auto;
  max-height: 600px;
}

.business-user-details-modal-modal_content-yqwil {
  padding: 0px 20px 8px;
}

.business-user-details-modal-detailItem_container-zXjDX {
  width: auto;
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 16px;
  padding: 18px 0px;
}

.business-user-details-modal-detailItem_title-TrGFO {
  font-size: 15px;
  font-weight: normal;
}

.business-user-details-modal-detailItem_text-L20PS {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.75);
}

.business-user-details-modal-detailItem_green-pdyba {
  color: var(--money-color);
}

.business-user-details-modal-activationSection-yPzjF {
  margin-top: 16px;
}

.business-user-details-modal-activationHeader-Clucs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.business-user-details-modal-activationTitle-WTVLn {
  color: var(--color-neutral-800);
  font-size: 15px;
  font-weight: 500;
}

.business-user-details-modal-active-gFwt3,
.business-user-details-modal-expired-VFq8W {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 500;
  border-radius: var(--radius-xl);
  padding: 5px 9px;
}

.business-user-details-modal-active-gFwt3 {
  color: var(--color-green-700);
  background-color: var(--color-green-50);
}

.business-user-details-modal-expired-VFq8W {
  color: var(--color-red-700);
  background-color: var(--color-red-50);
}

.business-user-details-modal-activationLink-d84H2 {
  display: flex;
  min-width: 0px;
  align-items: flex-start;
  gap: 8px;
  background-color: var(--color-neutral-100);
  border-radius: var(--radius-lg);
  padding: 7px 7px 7px 12px;
  margin-top: 12px;
}

.business-user-details-modal-link-ROiq3 {
  min-width: 0px;
  flex-grow: 1;
  color: var(--color-neutral-700);
  font-family: var(--font-mono);
  font-size: 14px;
  line-height: 18px;
  overflow-wrap: anywhere;
}

.business-user-details-modal-copyButton-RsrEZ {
  flex-shrink: 0;
}

.business-user-details-modal-updateLinkButton_base-Rpyga {
  width: 100%;
  margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/customer/business-users/business-user-details-modal/business-user-details-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,QAAQ;EACR,0CAA0C;EAC1C,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 324px;\n  height: auto;\n  max-height: 600px;\n}\n\n.modal_content {\n  padding: 0px 20px 8px;\n}\n\n.detailItem_container {\n  width: auto;\n  flex-wrap: wrap;\n  row-gap: 12px;\n  column-gap: 16px;\n  padding: 18px 0px;\n}\n\n.detailItem_title {\n  font-size: 15px;\n  font-weight: normal;\n}\n\n.detailItem_text {\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.detailItem_green {\n  color: var(--money-color);\n}\n\n.activationSection {\n  margin-top: 16px;\n}\n\n.activationHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.activationTitle {\n  color: var(--color-neutral-800);\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.active,\n.expired {\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: var(--radius-xl);\n  padding: 5px 9px;\n}\n\n.active {\n  color: var(--color-green-700);\n  background-color: var(--color-green-50);\n}\n\n.expired {\n  color: var(--color-red-700);\n  background-color: var(--color-red-50);\n}\n\n.activationLink {\n  display: flex;\n  min-width: 0px;\n  align-items: flex-start;\n  gap: 8px;\n  background-color: var(--color-neutral-100);\n  border-radius: var(--radius-lg);\n  padding: 7px 7px 7px 12px;\n  margin-top: 12px;\n}\n\n.link {\n  min-width: 0px;\n  flex-grow: 1;\n  color: var(--color-neutral-700);\n  font-family: var(--font-mono);\n  font-size: 14px;\n  line-height: 18px;\n  overflow-wrap: anywhere;\n}\n\n.copyButton {\n  flex-shrink: 0;\n}\n\n.updateLinkButton_base {\n  width: 100%;\n  margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `business-user-details-modal-modal_card-q9LS1`,
	"modal_content": `business-user-details-modal-modal_content-yqwil`,
	"detailItem_container": `business-user-details-modal-detailItem_container-zXjDX`,
	"detailItem_title": `business-user-details-modal-detailItem_title-TrGFO`,
	"detailItem_text": `business-user-details-modal-detailItem_text-L20PS`,
	"detailItem_green": `business-user-details-modal-detailItem_green-pdyba`,
	"activationSection": `business-user-details-modal-activationSection-yPzjF`,
	"activationHeader": `business-user-details-modal-activationHeader-Clucs`,
	"activationTitle": `business-user-details-modal-activationTitle-WTVLn`,
	"active": `business-user-details-modal-active-gFwt3`,
	"expired": `business-user-details-modal-expired-VFq8W`,
	"activationLink": `business-user-details-modal-activationLink-d84H2`,
	"link": `business-user-details-modal-link-ROiq3`,
	"copyButton": `business-user-details-modal-copyButton-RsrEZ`,
	"updateLinkButton_base": `business-user-details-modal-updateLinkButton_base-Rpyga`
};
export default ___CSS_LOADER_EXPORT___;
